import { Subscription } from 'rxjs/Subscription';

import type { FileState } from '@atlaskit/media-state/file-state';

import { type MediaSubscribable } from './types';
/**
 * This is a helper to transform the first value emitted by an MediaSubscribable into a Promise.
 *
 * @param mediaSubscribable a given MediaSubscribable<MediaSubscribableItem>
 * @param subscription a default Subscription (this parameter exists for testing purpose)
 */

export const toPromise = (
	mediaSubscribable: MediaSubscribable,
	subscription: Subscription = new Subscription(),
): Promise<FileState> =>
	new Promise((resolve, reject) =>
		subscription.add(
			mediaSubscribable.subscribe({
				next: (state) => {
					resolve(state);
					subscription.unsubscribe();
				},
				error: (error: any) => {
					reject(error);
					subscription.unsubscribe();
				},
			}),
		),
	);
